/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {ApiResponse, BaseComponent, Catalog} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {SourceDestination} from '../../../admin-shared/interfaces/source-destination';
import {Status} from '../../../admin-shared/interfaces/status';
import {FormConfigService} from '../../../admin-shared/services/form-config.service';
import {YandexImportService} from '../services/yandex-import.service';
import {YANDEX_FORM} from './yandex.config';

@Component({
  selector: 'app-yandex-import',
  templateUrl: 'yandex-import.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YandexImportComponent extends BaseComponent implements OnInit {

  title = translations.files;
  absolutePath = '/cabinet/dam/yandex-import';
  yandexFolders: string[];
  yandexSelectedFolder: string;
  damFolders: Observable<Catalog>;
  damSelectedFolder: string;
  model: any;
  step2 = false;
  form = new FormGroup({});
  options: FormlyFormOptions = {
    formState: {
      disabled: false,
    }
  };
  fields: FormlyFieldConfig[];
  downloadComplete: Observable<boolean> = this.yandexImportService.downloadComplete();
  downloadingStatus: Observable<Status>;

  private buffer: any[] = [];
  private bufferSize = 50;
  private numberOfItemsFromEndBeforeFetchingMore = 10;

  constructor(protected readonly formConfigService: FormConfigService,
              protected readonly yandexImportService: YandexImportService
  ) {
    super();

  }

  ngOnInit() {
    this.downloadingStatus = this.yandexImportService.requestDownloadingStatus();
    this.fields = this.formConfigService.setConfig(YANDEX_FORM)
      .formly()
      .getConfig();
    this.model = {};
  }

  onSubmit(): void {
    this.loading = true;
    this.yandexImportService.init(this.model)
      .pipe(take(1))
      .subscribe(success => this.handleSuccess(success), error => this.handleError(error));
  }

  download(): void {
    this.loading = true;

    const sourceDestination: SourceDestination = {
      fromYandexFolderName: this.yandexSelectedFolder,
      toDamCatalogId: Number(this.damSelectedFolder),
      tokenInfo: this.model
    };

    this.downloadingStatus = this.yandexImportService.download(sourceDestination).pipe(tap(_ => this.loading = false));
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({end}) {
    if (this.yandexFolders.length <= this.buffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.buffer.length) {
      this.fetchMore();
    }
  }

  private handleSuccess(response: ApiResponse<string[]>) {
    this.loading = false;
    this.step2 = true;
    this.yandexFolders = response.data;
    this.damFolders = this.yandexImportService.damFolders();
    this.cdr.detectChanges();
  }

  private fetchMore() {
    const len = this.buffer.length;
    const more = this.yandexFolders.slice(len, this.bufferSize + len);
    this.buffer = this.buffer.concat(more);
  }

}
